import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Input, Spinner } from 'reactstrap';
import { Dispatch } from 'redux';
import { Group } from '../../clients/aasServerClient.generated';
import { fetchTableGroups,fetchTableGroupsNoSearch } from '../../stores/groups/actionCreators';
import { getTableGroups } from '../../stores/groups/selectors';
import { isLoading } from '../../stores/navigation/selectors';
import { RootState } from '../../stores/store';
import DashboardContainer from '../dashboard/DashboardContainer';
import ViewContainer from '../layout/ViewContainer';
import Table from '../table/Table';
import TableBody from '../table/TableBody';
import TableColumn from '../table/TableColumn';
import TableHead from '../table/TableHead';
import TableToolbar from '../table/TableToolbar';
import GroupTableHead from './GroupsTableHead';
import GroupTableRow from './GroupsTableRow';
import GroupsToolbar from './GroupsToolbar';

export interface Props extends RouteComponentProps, LocalizeContextProps {
    groups: Group[];
    loading: boolean;
    lState : RootState;
    fetchGroups: () => void;
    fetchGroupsNoSearch: () => void;
}

export class GroupsPage extends React.Component<Props> {
    constructor(props: Props) {
        super(props);        
        this.props.lState.tables['groups'].search ='';
        this.props.fetchGroupsNoSearch();
    }

    public render() {
        const t = this.props.translate;
        return (
            <ViewContainer className="table-view">
                <div>
                    <h1>{t('groups.header.groups')}</h1>
                    {this.props.loading ? <Spinner /> : null}
                </div>
                <Table
                    toolbar={<GroupsToolbar />}
                    refresh={this.props.fetchGroups}
                    tableKey="groups"
                >
                    <GroupTableHead
                        refresh={this.props.fetchGroups}
                        ids={this.props.groups.map((u) => u.id)}
                    />
                    <TableBody>
                        {this.props.groups.map((group, i) => (
                            <GroupTableRow key={i} group={group} />
                        ))}
                    </TableBody>
                </Table>
            </ViewContainer >
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    groups: getTableGroups(state),
    loading: isLoading(state),
    lState : state,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchGroups: () => dispatch(fetchTableGroups()),
    fetchGroupsNoSearch : () => dispatch(fetchTableGroupsNoSearch()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(withRouter(GroupsPage)));
